var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.componentName)?_c(_vm.componentName,{tag:"component",attrs:{"payload":_vm.section.payload,"fields":_vm.section.fields}}):(_vm.section.fields && _vm.section.fields.length > 0)?_c('field-catalog-section',{attrs:{"section-key":_vm.section.sectionKey,"fields":_vm.section.fields}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }